{
    "browser": {
        "./node_modules/jsoneditor/dist/jsoneditor.min.js": "./node_modules/jsoneditor/dist/jsoneditor.js"
    },
    "name": "admin-web-app",
    "version": "2.6.2",
    "private": true,
    "dependencies": {
        "@cybusio/policy-validator": "1.0.4",
        "@cybusio/rule-engine": "1.1.6",
        "@dnd-kit/core": "6.3.1",
        "@dnd-kit/sortable": "10.0.0",
        "@emotion/react": "11.11.0",
        "@emotion/styled": "11.11.0",
        "@fontsource/roboto": "5.2.9",
        "@fontsource/roboto-mono": "5.2.8",
        "@formatjs/intl": "2.7.2",
        "@microlink/react-json-view": "1.27.0",
        "@mui/icons-material": "7.3.7",
        "@mui/lab": "7.0.1-beta.21",
        "@mui/material": "7.3.7",
        "@mui/system": "7.3.7",
        "@mui/utils": "7.3.7",
        "@mui/x-tree-view": "7.29.10",
        "@rjsf/core": "6.6.2",
        "@rjsf/mui": "6.6.2",
        "@rjsf/utils": "6.6.2",
        "@rjsf/validator-ajv8": "6.6.2",
        "ace-builds": "1.22.0",
        "ajv": "6.12.6",
        "classnames": "2.5.1",
        "csv-stringify": "6.4.6",
        "diacritics": "1.3.0",
        "js-yaml": "4.1.1",
        "json-schema": "0.4.0",
        "jsoneditor": "9.10.2",
        "jsonschema": "1.4.1",
        "mqtt": "5.15.0",
        "notistack": "3.0.1",
        "object-hash": "3.0.0",
        "promise-file-reader": "1.0.3",
        "qrcode.react": "3.1.0",
        "react": "18.2.0",
        "react-day-picker": "10.0.1",
        "react-dom": "18.2.0",
        "react-error-boundary": "3.1.4",
        "react-helmet": "6.1.0",
        "react-intl": "6.4.2",
        "react-is": "18.2.0",
        "react-router-dom": "5.3.4",
        "react-sync-promise": "1.0.9",
        "use-sync-external-store": "1.7.0",
        "zustand": "5.0.15"
    },
    "devDependencies": {
        "@babel/preset-react": "7.22.5",
        "@babel/preset-typescript": "7.22.5",
        "@cypress/code-coverage": "3.14.7",
        "@dprint/json": "0.25.1",
        "@dprint/markdown": "0.25.0",
        "@dprint/typescript": "0.96.1",
        "@formatjs/icu-messageformat-parser": "2.4.0",
        "@formatjs/intl-numberformat": "8.5.0",
        "@inquirer/prompts": "8.3.2",
        "@parcel/packager-raw-url": "2.16.3",
        "@parcel/transformer-webmanifest": "2.16.3",
        "@testing-library/react": "16.3.1",
        "@types/diacritics": "1.3.1",
        "@types/jest": "30.0.0",
        "@types/js-yaml": "4.0.9",
        "@types/jsoneditor": "9.9.6",
        "@types/object-hash": "3.0.2",
        "@types/react": "18.3.27",
        "@types/react-dom": "18.2.4",
        "@types/react-helmet": "6.1.6",
        "@types/react-router-dom": "5.3.3",
        "@types/strip-color": "0.1.0",
        "@typescript-eslint/eslint-plugin": "6.21.0",
        "babel-jest": "30.2.0",
        "babel-plugin-istanbul": "6.1.1",
        "buffer": "5.7.1",
        "chalk": "4.1.2",
        "core-js": "3.30.2",
        "cypress": "15.9.0",
        "depcheck": "1.4.3",
        "dockerfile-ast": "0.7.1",
        "dprint": "0.58.0",
        "eslint": "8.57.1",
        "eslint-config-standard-with-typescript": "43.0.1",
        "eslint-plugin-ferramentas": "2.0.1",
        "eslint-plugin-import": "2.32.0",
        "eslint-plugin-n": "16.6.2",
        "eslint-plugin-promise": "6.6.0",
        "eslint-plugin-react": "7.37.5",
        "eslint-plugin-typescript-sort-keys": "3.3.0",
        "events": "3.3.0",
        "history": "4.10.1",
        "jest": "30.2.0",
        "jest-environment-jsdom": "30.2.0",
        "jest-file-matcher": "1.0.2",
        "nyc": "15.1.0",
        "openapi-typescript": "7.4.3",
        "parcel": "2.16.3",
        "process": "0.11.10",
        "punycode": "2.3.1",
        "querystring-es3": "0.2.1",
        "strip-color": "0.1.0",
        "ts-json-schema-generator": "1.1.0",
        "ts-morph": "18.0.0",
        "tsx": "4.21.0",
        "typescript": "5.3.3",
        "url": "0.11.4",
        "utility-types": "3.10.0"
    },
    "scripts": {
        "fix:format": "eslint --fix '**/**/*.ts' '**/**/*.tsx' '**/**/*.js'; eslint_status=$?; dprint fmt && exit $eslint_status",
        "fix:format:unmerged": "tsx ./src/infrastructure/scripts/executables/format-unmerged.ts",
        "fix:format:ci": "npm run generate:env-config-metadata-file && npm run generate:schema-validators && npm run generate:capabilities && npm run fix:mark-unneeded-exports && npm run fix:format",
        "fix:mark-unneeded-exports": "tsx ./src/infrastructure/scripts/executables/mark-unneeded-exports.ts",
        "generate:build": "npm run generate:parcel-config && rm -rf build && parcel build src/infrastructure/parcel/index.html --config=./src/infrastructure/parcel/.parcelrc --no-autoinstall --log-level=info --public-url=/admin --dist-dir=build",
        "generate:env-config-metadata-file": "tsx ./src/infrastructure/scripts/executables/generate-env-config-metadata-file.ts",
        "generate:parcel-config": "tsx ./src/infrastructure/scripts/executables/generate-parcel-config.ts",
        "generate:capabilities": "tsx ./src/infrastructure/scripts/executables/generate-capabilities.ts",
        "generate:routes-config-file": "tsx ./src/infrastructure/scripts/executables/generate-routes-config-file.ts",
        "generate:env-file": "tsx ./src/infrastructure/scripts/executables/generate-env-file.ts",
        "generate:backend-schema-types": "tsx ./src/infrastructure/scripts/executables/backend-schema-types.ts --generate",
        "generate:schema-validators": "tsx ./src/infrastructure/scripts/executables/generate-schema-validators.ts",
        "generate:packages-file": "tsx ./src/infrastructure/scripts/executables/packages-file.ts --generate",
        "parcel:serve": "npm run generate:parcel-config && parcel serve src/infrastructure/parcel/index.html --config=./src/infrastructure/parcel/.parcelrc --no-autoinstall --log-level=info --public-url=/admin --dist-dir=build",
        "start:demo": "CYBUS_ADMIN_UI_BACKEND_HOST=demo.cybus.io npm run parcel:serve -- --https --port=8080",
        "start:docker": "npm run parcel:serve -- --host=0.0.0.0 --port=${CYBUS_ADMIN_UI_PORT} --hmr-port=${PARCEL_HMR_PORT} --lazy",
        "validate:coverage": "tsx ./src/infrastructure/scripts/executables/validate-coverage.ts",
        "test:e2e:coverage": "COVERAGE=true npm run test:e2e",
        "test:e2e": "cypress run --config-file=cypress.config.ts --browser chrome",
        "test:e2e:coverage:files": "tsx ./src/infrastructure/scripts/executables/generate-e2e-coverage-files.ts",
        "test:unit:coverage": "npm run test:unit -- --coverage",
        "test:unit": "jest --config test/jest/config.ts",
        "validate:backend-schema-types": "tsx ./src/infrastructure/scripts/executables/backend-schema-types.ts --validate",
        "validate:dependencies": "tsx ./src/infrastructure/scripts/executables/validate-dependencies.ts",
        "validate:translations": "tsx ./src/infrastructure/scripts/executables/validate-translations.ts",
        "validate:packages-file": "tsx ./src/infrastructure/scripts/executables/packages-file.ts --validate",
        "validate:pr-deleted-specs": "tsx ./src/infrastructure/scripts/executables/validate-pr-deleted-specs.ts",
        "validate:pr-size": "tsx ./src/infrastructure/scripts/executables/validate-pr-size.ts",
        "validate:circular-imports": "npx tsx src/infrastructure/scripts/executables/validate-circular-imports.ts",
        "validate:lint": "eslint --report-unused-disable-directives --max-warnings 33 '**/**/*.ts' '**/**/*.tsx' '**/**/*.js'",
        "validate:typescript": "tsc --noEmit",
        "postinstall": "tsx ./src/infrastructure/scripts/executables/post-install.ts",
        "prepare": "git config core.hooksPath .githooks || true",
        "update:docker-images": "tsx src/infrastructure/scripts/executables/update-docker-images.ts"
    },
    "browserslist": {
        "production": [
            ">0.2%",
            "not dead",
            "not op_mini all"
        ],
        "development": [
            "last 1 chrome version",
            "last 1 firefox version",
            "last 1 safari version"
        ]
    },
    "engines": {
        "node": "26.12.0"
    },
    "overrides": {
        "react-is": "18.2.0"
    },
    "@parcel/resolver-default": {
        "packageExports": true
    },
    "coverageThreshold": {
        "global": {
            "statements": 99.99,
            "branches": 99.83,
            "lines": 99.99,
            "functions": 100
        },
        "src/infrastructure/": {
            "statements": 99.98,
            "branches": 99.84,
            "lines": 99.98,
            "functions": 100
        },
        "src/infrastructure/types/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/react/": {
            "statements": 99.98,
            "branches": 99.78,
            "lines": 99.98,
            "functions": 100
        },
        "src/infrastructure/schema/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/http/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/RSTWebSocket/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/Connectware/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/CybusConfiguration/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/webstorage/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/assets/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/HTML5/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/file/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/mqtt/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/scripts/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/config/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/parcel/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/workers/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/FileService/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/FormatJS/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/infrastructure/RuleEngine/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/utils/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        },
        "src/domain/": {
            "statements": 100,
            "branches": 99.32,
            "lines": 100,
            "functions": 100
        },
        "src/application/": {
            "statements": 100,
            "branches": 100,
            "lines": 100,
            "functions": 100
        }
    }
}
